import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const getBalance = async (id: string) => httpRequest.get(`/inv/account/${id}/get_balance`);

export const select = async (data: any) => httpRequest.get("/inv/account", data);
